<template>
    <v-menu
        max-height="500"
        open-on-click
        botton
        offset-y
        nudge-bottom="5"
        close-delay="100">
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="alarm-key" >
                {{ alarmProcessed.alarmKey }}
            </span>
        </template>
        <v-list
            class="alarms-list"
        >
            <v-list-tile
                v-for="(item, index) in filteredPipelines"
                :key="index"
                @click.native="changeEditedAlarm(item.alarmKey)"
            >
                {{item.alarmKey}}
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'DeviceAlarmsMenu',
    data () {
        return {
            filteredPipelines: []
        }
    },
    mounted () {
        this.filteredPipelines = this.pipelines.filter(el => el.alarmKey !== this.alarmProcessed.alarmKey)
    },
    props: {
        alarmProcessed: {
            type: [Object],
            required: true
        },
        pipelines: {
            type: [Array],
            required: true
        }
    },
    watch: {
        alarmProcessed: {
            handler (newVal) {
                this.filteredPipelines = this.pipelines.filter(el => el.alarmKey !== newVal.alarmKey)
            },
            deep: true
        }
    },
    methods: {
        changeEditedAlarm (alarmKey) {
            this.$emit('changeProcessedAlarm', alarmKey)
        }
    }
}
</script>

<style lang="scss" scoped>
.alarm-key {
    color: $info;
    font-weight: bold;
    cursor: pointer;
    &:hover {
        color: lighten($info, 7%);
    }
}
::v-deep .alarms-list {
    cursor: pointer;
}
</style>
